import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading font-bold text-foreground-950 mb-4">
              韩漫网
            </h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              免费在线韩国漫画阅读平台，提供高清韩国漫画大全。资源齐全，界面简洁，是您休闲娱乐的可靠选择。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">
              快速导航
            </h4>
            <nav aria-label="页脚导航" className="space-y-2">
              <Link to="/" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">全部漫画</Link>
              <Link to="/about" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">关于我们</Link>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">
              热门分类
            </h4>
            <div className="space-y-2">
              {categories.slice(1, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">
              联系方式
            </h4>
            <div className="space-y-2 text-sm text-foreground-500">
              <p>邮箱：contact@hanmanwang.com</p>
              <p>工作时间：周一至周五 9:00-18:00</p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 韩漫网 - 免费在线漫画阅读平台。本站所有内容仅供学习交流。
          </p>
          <div className="flex items-center space-x-4">
            <a
              href="https://weibo.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-400 hover:text-primary-500 transition-colors"
              aria-label="微博"
            >
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a
              href="https://weixin.qq.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-400 hover:text-primary-500 transition-colors"
              aria-label="微信"
            >
              <i className="ri-wechat-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}